import { queryOptions } from '@tanstack/react-query'
import { contactGet } from 'Contact/api/ContactApi'

import { RequestStaleTime } from 'Common/utils/helpers/HelperQuery'

export const contactQueries = {
    all: () => ['contacts'],
    details: () => [...contactQueries.all(), 'detail'],
    detail: (id: number) =>
        queryOptions({
            queryKey: [...contactQueries.details(), id],
            queryFn: () => contactGet(id),
            staleTime: RequestStaleTime.default,
        }),
}
